import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Modal from "../../containers/common/Modal";
import { FlyInTransition } from "../../components/transitions/transitions";

import GymCard from "../../images/gym-bookings/gym-card.png";
import LeftArrow from "../../images/gym-bookings/left-arrow.svg";
import LocationLogo from '../../images/location-modal.svg';
import LocationDeniedLogo from '../../images/location-denied.svg';
import FitternityCard from '../../images/fitternity-card.svg';

const GymHomeCard = ({ cultPass }) => {
  const history = useHistory();

  /**
   * This state determines the state of the
   * popup which appears after user click
   * on Book Now Button
   */
  const [isLocationConsentModalOpen, setIsLocationConsentModalOpen] =
    useState(false);

  const [isLocationNotAllowedModalOpen, setIsLocationAllowedModalOpen] =
    useState(false);

  function hideLocationConsentModal() {
    setIsLocationConsentModalOpen(false);
  }

  function openLocationConsentModal() {
    setIsLocationConsentModalOpen(true);
  }

  function openLocationDeniedModal () {
    setIsLocationAllowedModalOpen(true);
  }

  function hideLocationDeniedModal(){
    setIsLocationAllowedModalOpen(false);
  }

  function redirectToRewards() {
    if (cultPass?.productId)
      history.push("/rewards/description", {
        product: cultPass,
      });
  }

  function redirectToGymBook() {
    history.push("/gym");
  }

  /**
   * Method for fetching the Location
   */
  function fetchLocation() {
    function successCallback(pos) {
      redirectToGymBook();
    }
    function failureCallback(err) {
      hideLocationConsentModal();
      openLocationDeniedModal();
    }
    navigator.geolocation.getCurrentPosition(successCallback, failureCallback, {
      timeout: 15000,
    });
  }

  /**
   * Handler for Book Now Button in Gym Card
   */
  function handleBookNow() {
    try {
      openLocationConsentModal();
    } catch (error) {
      console.error(error);
    }
  }


  return (
    <>
      <div className="flex w-full justify-center">
        <div className="flex flex-col justify-center items-center rounded-12 relative px-7">
          {/* <img
            src={GymCard}
            className="z-0 absolute z-0"
            height="200px"
            width="380px"
            alt="gym-card"
          />
          <div
            style={{
              height: "225px",
              width: "380px",
              background:
                "linear-gradient(90deg, rgba(58, 44, 160, 0.8) 0%, rgba(58, 44, 160, 0.7) 100%)",
            }}
            className="z-20 rounded-12 p-20px flex flex-col justify-between"
          >
            <div>
              <div className="text-title-l font-bold text-textbox ">
                Explore Gyms & Fitness Centres Nearby
              </div>
              <div className="text-body-m font-semibold text-textbox w-72 mt-8px">
                and book the best fitness option for you!
              </div>
            </div>
            <div className="flex w-full justify-between">
              <button
                onClick={redirectToRewards}
                className="p-10px px-24px rounded-full bg-textbox text-body-m font-semibold"
              >
                Redeem Cult Pass
              </button>
              <button
                onClick={handleBookNow}
                className="p-10px flex px-20px rounded-full items-center bg-textbox text-body-m font-semibold"
              >
                Book Now
                <img className="ml-8px" src={LeftArrow} alt="left-arrow" />
              </button>
            </div>
          </div> */}
          <div className="border-t border-boxCard mb-20 w-full" />
          <button onClick={handleBookNow}>
            <img src={FitternityCard} alt="gym-card" />
          </button>
        </div>
      </div>

      {isLocationConsentModalOpen && (
        <Modal
          showModal={isLocationConsentModalOpen}
          hideModal={hideLocationConsentModal}
        >
          <div className="modalContainer" onClick={hideLocationConsentModal}>
            <FlyInTransition
              in={isLocationConsentModalOpen}
              mountOnEnter
              unmountOnExit
              appear
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className="flex flex-col items-center justify-center bg-textbox rounded-12 p-20 pb-0"
                style={{ width: '85%', maxWidth:"400px"}}
              >
                <img src={LocationLogo} alt="location" />
                <h2 className="text-title-m font-bold mt-20 mb-10">Allow Location Access</h2>
                <p className="text-title-s font-medium text-center px-4">
                  Please provide location access to complete gym session booking
                </p>

                <div className="border-t border-txtlight-shades4 w-full mt-30 flex justify-between ">
                  <button
                    className="text-title-m font-semibold w-half p-15 "
                    onClick={hideLocationConsentModal}
                  >Cancel</button>
                  <div
                    className="border-r border-txtlight-shades4 h-6 mt-15"
                  ></div>
                  <button
                    className="text-title-m text-primary font-semibold w-half p-15"
                    onClick={fetchLocation}
                  >Proceed</button>
                </div>
              </div>
            </FlyInTransition>
          </div>
        </Modal>
      )}

      {isLocationNotAllowedModalOpen &&  (
         <Modal
          showModal={isLocationNotAllowedModalOpen}
          hideModal={hideLocationDeniedModal}
        >
          <div className="modalContainer" onClick={hideLocationDeniedModal}>
            <FlyInTransition
              in={isLocationNotAllowedModalOpen}
              mountOnEnter
              unmountOnExit
              appear
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className="flex flex-col items-center justify-center bg-textbox rounded-12 p-20 "
                style={{ width: '85%', maxWidth:"400px" }}
              >
                <img src={LocationDeniedLogo} alt="location" />
                <h2 className="text-title-m font-bold mt-20 mb-10">
                Couldn't access your Location
                </h2>
                <p className="text-title-s font-medium text-center px-4">
                  We are unable to fetch your location. Please allow location access from settings.
                </p>

                <button
                className="text-title-m text-textbox bg-primary font-semibold w-full p-10 rounded-lg mt-30"
                  onClick={hideLocationDeniedModal}
                >Okay</button>
              </div>
            </FlyInTransition>
          </div>
        </Modal>
      )}
    </>
  );
};

export default GymHomeCard;
